(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tm-bundle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tm-bundle-picker')) {
  class TMBundlePicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-tmb-config]').textContent);
      this.words = JSON.parse(this.querySelector('[data-tmb-strings]').textContent);
      this.count = 1;
      this.busy = false;
      this.catalog = [...new Map([this.config.current, ...this.config.catalog].filter(p => !p.gift_card && p.available).map(p => [p.id,p])).values()];
      const p = this.config.current;
      this.slots = [{p, v:p.variants.find(v => v.id === this.config.variant) || p.variants[0]},null,null,null,null];
      this.addEventListener('click', e => this.onClick(e));
      this.addEventListener('change', e => {
        if (!e.target.matches('[data-slot-variant]')) return;
        const index = Number(e.target.dataset.slotVariant);
        this.slots[index].v = this.slots[index].p.variants.find(v => String(v.id) === e.target.value);
        this.render();
      });
      this.querySelector('.tmb__search').addEventListener('input', () => this.renderCatalog());
      this.querySelector('dialog').addEventListener('close', () => {
        this.querySelector(`[data-choose="${this.picking}"]`)?.focus({preventScroll:true});
      });
      this.querySelector('.tmb__search').addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          const first = this.querySelector('.tmb__catalog button');
          if (first) { event.preventDefault(); first.focus(); }
        }
      });
      this.render();
    }
    money(cents) { return this.config.currency === 'BDT' ? 'Tk ' + new Intl.NumberFormat('en-BD',{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100) : new Intl.NumberFormat('en',{style:'currency',currency:this.config.currency || 'BDT'}).format(cents/100); }
    pct(n) { return String(Math.round(n*100)/100); }
    escape(s) { const e=document.createElement('span'); e.textContent=String(s ?? ''); return e.innerHTML; }
    pricing(v,n) {
      const base = Math.max(v.price, v.compare_at_price || 0);
      const rate = Math.min(100, Math.max(0, Number(this.config.rates[n-1]) || 0));
      const extra = Math.min(v.price, Math.round(v.price * rate / 100));
      return {base, price:v.price-extra, sale:base ? (base-v.price)*100/base : 0, rate, extra};
    }
    badge(v,n) { const p=this.pricing(v,n);return n===1 ? `${this.pct(p.sale)}% ${this.words.off}` : `${this.pct(p.sale)}% + ${this.pct(p.rate)}% ${this.words.off}`; }
    image(p,v) { return v?.featured_image?.src || p.featured_image || p.images?.[0] || ''; }
    render() {
      const e=s=>this.escape(s), w=this.words, anchor=this.slots[0];
      this.querySelector('.tmb__offers').innerHTML=w.names.map((name,i)=>{
        const n=i+1, price=this.pricing(anchor.v,n), active=this.count===n;
        return `<div class="tmb__offer ${active?'is-selected':''}"><button type="button" role="radio" aria-checked="${active}" tabindex="${active?0:-1}" class="tmb__offer-head" data-count="${n}"><span class="tmb__dot" aria-hidden="true"></span><span><span class="tmb__title-line"><strong class="tmb__name">${e(name)}</strong><span class="tmb__badge">${e(this.badge(anchor.v,n))}</span></span><small class="tmb__sub">${e(n===1?w.just_one:w.mix.replace('{count}',n))}</small></span><span class="tmb__prices">${price.base>price.price?`<s>${e(this.money(price.base))}</s>`:''}<span>${e(this.money(price.price))}</span><small>${e(w.each)}</small></span></button>${n===3?`<span class="tmb__ribbon">${e(w.popular)}</span>`:''}${n===5?`<span class="tmb__ribbon">${e(w.best)}</span>`:''}${active?`<div class="tmb__slots">${Array.from({length:n},(_,j)=>this.slotHtml(j)).join('')}</div>`:''}</div>`;
      }).join('');
      this.querySelectorAll('[role="radio"]').forEach(button=>button.addEventListener('keydown',event=>{
        if(!['ArrowDown','ArrowRight','ArrowUp','ArrowLeft','Home','End'].includes(event.key))return;
        event.preventDefault();const direction=['ArrowDown','ArrowRight'].includes(event.key)?1:-1;
        this.count=event.key==='Home'?1:event.key==='End'?5:((this.count-1+direction+5)%5)+1;
        this.render();this.querySelector(`[data-count="${this.count}"]`).focus();
      }));
      const chosen=this.slots.slice(0,this.count), filled=chosen.filter(Boolean);
      const total=filled.reduce((s,item)=>s+this.pricing(item.v,this.count).price,0);
      const original=filled.reduce((s,item)=>s+this.pricing(item.v,this.count).base,0);
      this.querySelector('.tmb__summary').innerHTML=`<span>${e(w.total)} (${filled.length}/${this.count})<small>${e(w.save)} ${e(this.money(original-total))}</small></span><span>${e(this.money(total))}</span>`;
      const addButton=this.querySelector('.tmb__add'), buyButton=this.querySelector('.tmb__buy');
      const incomplete=filled.length!==this.count, sold=filled.some(item=>!item.v.available), preview=this.count>1&&this.dataset.enabled!=='true';
      const disabled=this.busy||incomplete||sold||preview;
      addButton.disabled=disabled;buyButton.disabled=disabled;
      addButton.textContent=this.busy?w.adding:incomplete?w.select_all:sold?w.sold_out:preview?w.preview:w.add;
      buyButton.textContent=this.busy?w.adding:incomplete?w.select_all:sold?w.sold_out:preview?w.preview:w.buy;
    }
    slotHtml(index) {
      const slot=this.slots[index],e=s=>this.escape(s),w=this.words;
      if(!slot)return `<div class="tmb__slot"><button type="button" class="tmb__choose" data-choose="${index}">＋ ${e(w.choose)} ${index+1}</button></div>`;
      const {p,v}=slot,price=this.pricing(v,this.count);
      return `<div class="tmb__slot"><img src="${e(this.image(p,v))}" alt="${e(p.title)}" width="48" height="60"><div><strong class="tmb__slot-title">${index+1}. ${e(p.title)}</strong><div class="tmb__slot-price"><s>${e(this.money(price.base))}</s><span>${e(this.money(price.price))}</span><small>${e(this.badge(v,this.count))}</small></div><label class="tmb__variant-label">${e(w.size)}<select data-slot-variant="${index}">${p.variants.map(variant=>`<option value="${variant.id}" ${variant.id===v.id?'selected':''} ${!variant.available?'disabled':''}>${e(variant.title)}${!variant.available?' — '+e(w.sold_out):''}</option>`).join('')}</select></label>${index?`<button type="button" class="tmb__change" data-choose="${index}">${e(w.choose)}</button>`:''}</div></div>`;
    }
    renderCatalog() {
      const normalize=value=>String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
      const q=normalize(this.querySelector('.tmb__search').value),e=s=>this.escape(s);
      const tokens=q.split(/\s+/).filter(Boolean);
      const products=this.catalog.filter(p=>tokens.every(token=>normalize(p.title).includes(token)));
      this.querySelector('.tmb__results-count').textContent=this.words.results.replace('{count}',products.length);
      this.querySelector('.tmb__empty').hidden=products.length>0;
      this.querySelector('.tmb__catalog').innerHTML=products.map(p=>{const v=p.variants.find(v=>v.available);return `<button type="button" data-product="${p.id}"><img src="${e(this.image(p,v))}" alt="${e(p.title)}" width="180" height="225" loading="lazy"><strong>${e(p.title)}</strong><span>${e(this.money(this.pricing(v,this.count).price))}</span></button>`;}).join('');
    }
    onClick(event) {
      const target=event.target.closest('button');if(!target||this.busy)return;
      if(target.dataset.count){this.count=Number(target.dataset.count);this.render();this.querySelector(`[data-count="${this.count}"]`).focus();}
      if(target.dataset.choose!==undefined){this.picking=Number(target.dataset.choose);this.returnFocus=target;this.querySelector('.tmb__search').value='';this.renderCatalog();this.querySelector('dialog').showModal();this.querySelector('.tmb__search').focus({preventScroll:true});}
      if(target.hasAttribute('data-close'))this.querySelector('dialog').close();
      if(target.dataset.product){const p=this.catalog.find(p=>String(p.id)===target.dataset.product);this.slots[this.picking]={p,v:p.variants.find(v=>v.available)};this.querySelector('dialog').close();this.render();this.querySelector(`[data-choose="${this.picking}"]`)?.focus();}
      if(target.matches('[data-tmb-action]'))this.add(target.dataset.tmbAction);
    }
    async request(path,body) {
      const r=await fetch(this.dataset.root+path,{method:body?'POST':'GET',headers:{'Content-Type':'application/json'},...(body?{body:JSON.stringify(body)}:{})});
      const data=await r.json();if(!r.ok)throw new Error(data.description||data.message||this.words.error);return data;
    }
    async add(destination='cart') {
      if(this.busy || (this.count>1&&this.dataset.enabled!=='true'))return;
      const selected=this.slots.slice(0,this.count);if(selected.some(x=>!x||!x.v.available))return;
      this.busy=true;const error=this.querySelector('.tmb__error');error.hidden=true;this.render();
      try {
        const token='tm-'+crypto.randomUUID();
        const counts=new Map();selected.forEach(({v})=>counts.set(v.id,(counts.get(v.id)||0)+1));
        const items=[...counts].map(([id,quantity])=>({id,quantity,...(this.count>1?{properties:{_tm_bundle:token,_tm_bundle_size:String(this.count)}}:{})}));
        await this.request('cart/add.js',{items});
        if(this.count>1){
          let cart=await this.request('cart.js');
          let added=cart.items.filter(item=>item.properties?._tm_bundle===token);
          const requiredRate=Math.min(100,Math.max(0,Number(this.config.rates[this.count-1])||0));
          const hasVerifiedDiscount=(data)=>{
            const applications=[...(data.cart_level_discount_applications||[]),...(data.discount_applications||[])];
            return applications.some(discount=>{
              const title=String(discount.title||'');
              const value=Number(discount.value||0);
              return title.startsWith('TM Bundle —') && (!discount.value_type || discount.value_type==='percentage') && value+0.001>=requiredRate;
            });
          };
          if(!hasVerifiedDiscount(cart)){
            await new Promise(resolve=>setTimeout(resolve,300));
            cart=await this.request('cart.js');
            added=cart.items.filter(item=>item.properties?._tm_bundle===token);
          }
          if(added.reduce((sum,item)=>sum+item.quantity,0)!==this.count || !hasVerifiedDiscount(cart)){
            const updates=Object.fromEntries(added.map(item=>[item.key,0]));
            if(added.length)await this.request('cart/update.js',{updates});
            throw new Error(this.words.mismatch);
          }
        }
        window.location.assign(destination==='checkout'?this.dataset.root+'checkout':this.dataset.cartUrl);
      } catch(err){error.textContent=err.message||this.words.error;error.hidden=false;this.busy=false;this.render();}
    }
  }
  customElements.define('tm-bundle-picker',TMBundlePicker);
}
  } catch(e) { console.error(e); }
})();

})();
